import { useEffect, useState } from "react";
import styled, { css } from "styled-components";

// Logos OneWork usados quando a empresa não enviou o seu (ou ele não carrega).
export const OW_ASSETS = { full: "/onework-f.png", symbol: "/ow.png", symbolLight: "/ow-white.png" };

const Box = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  overflow: hidden;

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    object-position: left center;
  }

  ${(p) =>
    p.$kind === "symbol"
      ? css`
          width: var(--ow-logo-symbol);
          height: var(--ow-logo-symbol);
          justify-content: center;
          border-radius: 8px;
          img {
            object-position: center;
          }
        `
      : css`
          height: var(--ow-logo-full-h);
          max-width: var(--ow-logo-full-w);
        `}
`;

/**
 * Área de logo da empresa com caixa de tamanho fixo: `full` na topbar (28px de
 * altura, até 140px), `symbol` no mobile (32×32). Sem `src`, ou se a imagem não
 * carregar, mostra o logo OneWork sem mexer no layout. Nunca pinta o logo.
 */
export default function TenantLogo({ kind = "full", src, companyName, fallbackFull, fallbackSymbol, className }) {
  const fallback = kind === "symbol" ? fallbackSymbol || OW_ASSETS.symbol : fallbackFull || OW_ASSETS.full;
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const current = src && !failed ? src : fallback;
  const isFallback = current === fallback;

  return (
    <Box $kind={kind} className={className} title={companyName}>
      <img
        src={current}
        alt={isFallback ? "OneWork" : companyName || "Logo da empresa"}
        onError={() => {
          if (!failed) setFailed(true);
        }}
      />
    </Box>
  );
}
